import { Component, Input } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { gsap, Quad } from 'gsap';

@Component({
    selector: 'app-day-buttons-list',
    templateUrl: './day-buttons-list.component.html',
    styleUrls: ['./day-buttons-list.component.scss']
})
export class DayButtonsListComponent {

    @Input('color1') color1: string
    @Input('color2') color2: string
    @Input('color3') color3: string
    @Input('color4') color4: string

    public position: number = 0
    
    constructor(
        public apiService: ApiService
    ) {

    }

    selectDay(index: number) {
        let dayID = this.apiService.daysList[index].id

        this.apiService.selectDay(dayID)
    }

    onLeft() {
        gsap.to('.dayButtonsSlider', 0.5, {x: '0vw', ease: Quad.easeOut});
    }

    onRight() {
        gsap.to('.dayButtonsSlider', 0.5, {x: '-31vw', ease: Quad.easeOut});
    }
}
